import { FC } from 'react';
import Header from '../components/header/header';
import Footer from '../components/footer/footer';

const AUREUS = {
  green: '#6FC2AE',
  blue: '#609EBD',
  navy: '#01263D',
  purple: '#4643D3'
};

const NotFoundPage: FC = () => {
  return (
    <div
      className="min-h-screen text-white flex flex-col"
      style={{
        background: `linear-gradient(to bottom, ${AUREUS.navy}, #0a1a2f)`
      }}
    >
      <Header />

      <main className="flex-1 flex flex-col items-center justify-center px-6 pt-32 pb-20 text-center">
        <p
          className="text-sm uppercase tracking-[0.2em] mb-4 opacity-70"
          style={{ color: AUREUS.blue }}
        >
          404
        </p>
        <h1 className="text-4xl md:text-5xl font-black mb-4">
          Page not found
        </h1>
        <p className="text-lg opacity-80 max-w-md mb-10">
          That link doesn&apos;t exist. Head home or grab the app on the App
          Store.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="/"
            className="px-8 py-3 rounded-xl font-medium transition-all"
            style={{
              background: AUREUS.green,
              color: AUREUS.navy
            }}
          >
            Back to home
          </a>
          <a
            href="/support"
            className="px-8 py-3 rounded-xl font-medium transition-all"
            style={{
              background: 'rgba(70, 67, 211, 0.12)',
              border: `1px solid rgba(96, 158, 189, 0.35)`,
              color: AUREUS.blue
            }}
          >
            FAQ / Help
          </a>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFoundPage;
